import { useMediaQuery } from "@chakra-ui/react";

const useMediaQueryDesktop = () => useMediaQuery("(min-width: 62em)")[0];

export default useMediaQueryDesktop;
